<!--
 * @Description: 最新上报故障
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-22 14:22:25
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-29 11:03:19
 -->
<template>
  <div class="releaseFault">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">最新上报事件</span>
    </div>
    <div class="list">
      <div class="listHeader">
        <span class="describeTitle">事件描述</span>
        <span class="deptTitle">上报单位</span>
      </div>
      <div class="listItem" v-for="(item, index) in list" :key="index">
        <el-tooltip class="item" effect="light" :content="item.content" placement="top-start">
          <span class="describe">{{item.content}}</span>
        </el-tooltip>
        <span class="dept">{{item.customerName}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'releaseFault',
  components: {
  },
  data () {
    return {
      list: [],
    }
  },
  methods: {
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/lcgl/page', {
        pageNo: 1,
        pageSize: 10,
      }).then(res => {
        if (res.code === 0) {
          console.log(res.data.list)
          this.list = res.data.list
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .releaseFault {
    width: 88%;
    height: 100%;
    background: url('/static/img/layout/tableBg.png');
    background-size: 100% 100%;
    margin-left: 5%;
    .titleHeader {
      width: 100%;
      height: 4vh;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      >img {
        height: 100%;
        margin-right: 20px;
      }
      .titleName {
        font-family: SourceHanSansCN-Bold;
        font-size: 1.5vh;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #05dbe3;
      }
    }
    .list {
      width: 100%;
      height: 90%;
      overflow-y: scroll;
      .listHeader {
        width: 100%;
        background: rgb(24, 49, 55);
        height: 10%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.4vh;
        font-weight: bold;
        color: #fff;
        border-image: url('/static/img/layout/line.png') 30 30 stretch;
        .describeTitle {
          display: inline-block;
          width: 70%;
          text-align: center;
        }
        .deptTitle {
          display: inline-block;
          width: 30%;
          text-align: center;
        }
      }
      .listItem {
        width: 100%;
        height: 10%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.3vh;
        color: #d7fdff;
        &:nth-of-type(odd) {
          background: rgb(24, 49, 55);
        }
        &:nth-of-type(even) {
          background: rgb(24, 36, 40);
        }
        .describe {
          display: inline-block;
          width: 60%;
          text-align: left;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          padding: 0 5%;
        }
        .dept {
          display: inline-block;
          width: 30%;
          text-align: center;
        }
      }
    }
  }
</style>
